module.exports = __webpack_public_path__ + "assets/img/NPC040.c80e4031.png";